import React from "react";
import { TooltipContainer } from "./style";

export default function LoadOutTooltip({ label }) {
  return <TooltipContainer className="loadTooltip">{label}</TooltipContainer>;
}
